export default "__VITE_ASSET__D0P52emT__"